import { connect } from 'react-redux';
import React from 'react';
import * as selectors from 'app/selectors';
import { FIX_LOCATION } from 'app/constants/hint';
import LocationRoleUsersForm from './LocationRoleUsersForm';

function LocationSettingSalesForm({ updateLocation, users, salesManager }) {
  return (
    <LocationRoleUsersForm
      updateLocation={updateLocation}
      users={users}
      fields={[
        {
          name: 'sales_ids',
          role: 'sales',
          title: '招商人员',
          hint: FIX_LOCATION.sales,
          selectedUsers: salesManager
        }
      ]}
    />
  );
}

function mapStateToProps(state, props) {
  const { loc_id } = props;
  return {
    users: selectors.getSpaceUsers(state),
    salesManager: selectors.getTeamRolesOfLocation(state, loc_id, 'sales')
  };
}

export default connect(mapStateToProps)(LocationSettingSalesForm);
